import { api } from "@/services/api"
import { useQuery } from "@tanstack/vue-query"
import type { MaybeRef } from "vue"

export type ListCustomersResponseItem = {
  id: string
  name: string
  email: string | null
  phone: string | null
  totalPayments: number
}

export type ListCustomersFilter = {
  search?: string
}

export type ListCustomersQuery = ListCustomersFilter &
  Pagination

const listCustomers = async (
  query?: ListCustomersQuery
): Promise<Paginate<ListCustomersResponseItem[]>> => {
  const { body } = await api.get<
    RecursivelyConvertDatesToStrings<
      Paginate<ListCustomersResponseItem[]>
    >
  >("/beepaidgo/customers/", { query })

  return body
}

export const useCustomers = (
  query?: MaybeRef<ListCustomersQuery>
) =>
  useQuery({
    queryKey: [CUSTOMERS_QUERY_KEY, query] as const,
    queryFn: ({ queryKey: [_, query_] }) =>
      listCustomers(query_),
  })
